import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { updateUserProfile } from '../../redux/user/actions';
import { useDispatchPromise } from '../../utils/AppUtils';
import { catchAsync } from '../../utils/AppUtils';
import { navigateToDashboardForView } from '../../utils/dashboardView';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { BRAND_LUXE_PRIMARY } from '../../pages/BrandDashboard/brandDashboardTokens';

export interface BrandDashboardInviteEmptyHintProps {
    onBeforeSwitch?: () => void;
}

export function BrandDashboardInviteEmptyHint({ onBeforeSwitch }: BrandDashboardInviteEmptyHintProps) {
    const navigate = useNavigate();
    const dispatchPromise = useDispatchPromise();

    const handleSwitchToBrand = catchAsync(async () => {
        onBeforeSwitch?.();
        await dispatchPromise(updateUserProfile({ dashboard_view: 'brand' }));
        navigateToDashboardForView(navigate, 'brand');
    });

    return (
        <Typography
            component="p"
            sx={{
                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                fontSize: 14,
                color: '#adaaaa',
                lineHeight: 1.6,
                m: 0,
            }}>
            No campaigns yet. Switch to the{' '}
            <Box
                component="button"
                type="button"
                onClick={handleSwitchToBrand}
                sx={{
                    display: 'inline',
                    border: 'none',
                    background: 'none',
                    padding: 0,
                    font: 'inherit',
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                    color: BRAND_LUXE_PRIMARY,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px',
                    '&:hover': {
                        color: '#feb700',
                    },
                }}>
                Brand
            </Box>{' '}
            dashboard to create a campaign and send invites.
        </Typography>
    );
}
